const getDefaultState = () => ({
    groups: [],
});

const state = () => getDefaultState();

const getters = {
    groupCount: (state) => state.groups.length,
    couponGivenTotal: (state, getters) => getters.groupCount,
    groupList: (state) => state.groups,
};

const actions = {
    groupCreated({ commit }, payload) {
        commit('addGroup', payload);
        return { status: 'success', message: payload };
    },
    setGroups({ commit }, groups) {
        commit('setGroups', groups);
    },
    resetGroupsState({ commit }) {
        commit('resetState');
    },
};

const mutations = {
    addGroup(state, payload) {
        const newGroup = { ...payload, groupId: state.groups.length + 1 };
        state.groups.push(newGroup);
    },
    setGroups(state, groups) {
        state.groups = Array.isArray(groups) ? groups : [];
    },
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
